<template>
  <section class="app-content" :class="{
      'expanding': expanding,
      'chinese': language === 'zh-CN',
      'english': language !== 'zh-CN'
    }">
    <page-header @expand="expand"></page-header>
    <keep-alive >
      <router-view class="page-content" ref="pageContent" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view class="page-content" ref="pageContent" v-if="!$route.meta.keepAlive"></router-view>
    <div class="footer-wrapper">
      <FootBar />
    </div>
  </section>
</template>

<script>
import FootBar from '@xpeng/footbar';
import PageHeader from './header.vue'
import cookie from 'js-cookie'

export default {
  name: 'AppContent',
  components: {
    PageHeader,
    FootBar
  },
  data() {
    return {
      language: this.$i18n.locale,
      expanding: Boolean(cookie.get('__content_expanding') === '1')
    }
  },
  watch: {
    '$i18n.locale'(newVal) {
      this.language = newVal;
    }
  },
  mounted () {
    this.$store.commit('setPageContent', this.$refs.pageContent)
  },
  methods: {
    expand () {
      this.expanding = !this.expanding
      this.expanding ? cookie.set('__content_expanding', '1') : cookie.set('__content_expanding', '0')
      this.toggleSidebar()
    },
    toggleSidebar () {
      if (!this.expanding) {
        this.$store.commit('closeSidebar')
      } else {
        this.$store.commit('openSidebar')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-content {
  position: absolute;
  top: 60px;
  bottom: 0;
  right: 0;

  // z-index: 100;
  padding-bottom: 60px;
  background: #fafafa;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05), 0 4px 24px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

  &.chinese {
    left: 200px;
  }

  &.english {
    left: 256px;
  }

  &.expanding {
    left: 64px;
  }

  .footer-wrapper{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .page-content{
    padding: 16px;
    position: absolute;
    width: 100%;
    top: 53px;
    bottom: 30px;
    overflow-y: scroll;
  }
}
</style>
